import { Plus, X } from "lucide-react";
import { useState } from "react";
import { splitEmails } from "../../lib/formatters";
import { Button } from "../../components/ui/Button";
import { TextInput } from "../../components/ui/Form";

export default function RecipientEditor({ label, emails, onChange, suggestions = [] }) {
  const [value, setValue] = useState("");
  const add = (candidate = value) => {
    const next = splitEmails(candidate);
    if (!next.length) return;
    onChange([...new Set([...emails, ...next])]);
    setValue("");
  };
  return (
    <div className="recipient-editor">
      <span>{label}</span>
      <div className="recipient-editor__control">
        <div className="email-chips">
          {emails.map((email) => (
            <span key={email}>{email}<button type="button" aria-label={`删除 ${email}`} onClick={() => onChange(emails.filter((item) => item !== email))}><X size={13} /></button></span>
          ))}
          <TextInput
            value={value}
            onChange={(event) => setValue(event.target.value)}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === "," || event.key === ";") {
                event.preventDefault();
                add();
              }
            }}
            onBlur={() => add()}
            placeholder={emails.length ? "继续添加" : `输入${label}邮箱`}
            aria-label={`${label}邮箱`}
          />
        </div>
        <Button size="sm" variant="ghost" icon={Plus} onClick={() => add()}>添加</Button>
      </div>
      {suggestions.length ? (
        <div className="recipient-suggestions">
          {suggestions.filter((item) => !emails.includes(item.email || item)).slice(0, 5).map((item) => {
            const email = item.email || item;
            return <button type="button" key={email} onClick={() => add(email)}>{email}</button>;
          })}
        </div>
      ) : null}
    </div>
  );
}
